/* src/app/components/user/UserHeader/styles.js */

export default theme => ({
  avatar: {
    width: 80,
    height: 80,
    marginBottom: theme.spacing.unit,
  },
  avatarWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});



// WEBPACK FOOTER //
// ./src/app/components/user/UserHeader/styles.js